import React, { useState, useEffect } from "react";

import Paper from "@material-ui/core/Paper";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import TextField from "@material-ui/core/TextField";
import FormHelperText from "@material-ui/core/FormHelperText";
import Typography from "@material-ui/core/Typography";
import CallIcon from "@material-ui/icons/Call";
import GroupAddIcon from "@material-ui/icons/GroupAdd";
import HourglassEmptyIcon from "@material-ui/icons/HourglassEmpty";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import AccessAlarmIcon from '@material-ui/icons/AccessAlarm';
import TimerIcon from '@material-ui/icons/Timer';

import { makeStyles } from "@material-ui/core/styles";
import { grey, blue } from "@material-ui/core/colors";
import { toast } from "react-toastify";

import ButtonWithSpinner from "../../components/ButtonWithSpinner";

import { isArray } from "lodash";

import useDashboard from "../../hooks/useDashboard";
import { ChatsUser } from "./ChartsUser"

import { isEmpty } from "lodash";
import moment from "moment";
import { ChartsDate } from "./ChartsDate";
import { TagsReport } from "./TagsReport";
import { i18n } from "../../translate/i18n";

const useStyles = makeStyles((theme) => ({
  container: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(2),
  },
  fixedHeightPaper: {
    padding: theme.spacing(2),
    display: "flex",
    flexDirection: "column",
    height: 240,
    overflowY: "auto",
    ...theme.scrollbarStyles,
  },
  cardAvatar: {
    fontSize: "55px",
    color: grey[500],
    backgroundColor: "#ffffff",
    width: theme.spacing(7),
    height: theme.spacing(7),
  },
  cardTitle: {
    fontSize: "18px",
    color: blue[700],
  },
  cardSubtitle: {
    color: grey[600],
    fontSize: "14px",
  },
  alignRight: {
    textAlign: "right",
  },
  fullWidth: {
    width: "100%",
  },
  selectContainer: {
    width: "100%",
    textAlign: "left",
  },
  iframeDashboard: {
    width: "100%",
    height: "calc(100vh - 64px)",
    border: "none",
  },
  customFixedHeightPaper: {
    padding: theme.spacing(2),
    display: "flex",
    overflow: "auto",
    flexDirection: "column",
    height: 120,
  },
  customFixedHeightPaperLg: {
    padding: theme.spacing(2),
    display: "flex",
    overflow: "auto",
    flexDirection: "column",
    height: "100%",
  },
    card0: {
    padding: theme.spacing(2),
    display: "flex",
    overflow: "auto",
    flexDirection: "column",
    height: "100%",
    minHeight: 140,
    background: "linear-gradient(135deg, #0ea5e9 0%, #0284c7 100%)",
    color: "#ffffff",
    borderRadius: 12,
    boxShadow: "0 2px 12px rgba(14, 165, 233, 0.25)",
    transition: "all 0.3s ease",
    "&:hover": {
      transform: "translateY(-2px)",
      boxShadow: "0 4px 20px rgba(14, 165, 233, 0.35)",
    },
    [theme.breakpoints.down('sm')]: {
      minHeight: 120,
      padding: theme.spacing(1.5),
    },
  },
  card00: {
    padding: theme.spacing(2),
    display: "flex",
    overflow: "auto",
    flexDirection: "column",
    height: "100%",
    minHeight: 140,
    background: "linear-gradient(135deg, #8b5cf6 0%, #7c3aed 100%)",
    color: "#ffffff",
    borderRadius: 12,
    boxShadow: "0 2px 12px rgba(139, 92, 246, 0.25)",
    transition: "all 0.3s ease",
    "&:hover": {
      transform: "translateY(-2px)",
      boxShadow: "0 4px 20px rgba(139, 92, 246, 0.35)",
    },
    [theme.breakpoints.down('sm')]: {
      minHeight: 120,
      padding: theme.spacing(1.5),
    },
  },
  card1: {
    padding: theme.spacing(2),
    display: "flex",
    overflow: "auto",
    flexDirection: "column",
    height: "100%",
    minHeight: 140,
    background: "linear-gradient(135deg, #10b981 0%, #059669 100%)",
    color: "#ffffff",
    borderRadius: 12,
    boxShadow: "0 2px 12px rgba(16, 185, 129, 0.25)",
    transition: "all 0.3s ease",
    "&:hover": {
      transform: "translateY(-2px)",
      boxShadow: "0 4px 20px rgba(16, 185, 129, 0.35)",
    },
    [theme.breakpoints.down('sm')]: {
      minHeight: 120,
      padding: theme.spacing(1.5),
    },
  },
  card2: {
    padding: theme.spacing(2),
    display: "flex",
    overflow: "auto",
    flexDirection: "column",
    height: "100%",
    minHeight: 140,
    background: "linear-gradient(135deg, #f59e0b 0%, #d97706 100%)",
    color: "#ffffff",
    borderRadius: 12,
    boxShadow: "0 2px 12px rgba(245, 158, 11, 0.25)",
    transition: "all 0.3s ease",
    "&:hover": {
      transform: "translateY(-2px)",
      boxShadow: "0 4px 20px rgba(245, 158, 11, 0.35)",
    },
    [theme.breakpoints.down('sm')]: {
      minHeight: 120,
      padding: theme.spacing(1.5),
    },
  },
  card3: {
    padding: theme.spacing(2),
    display: "flex",
    overflow: "auto",
    flexDirection: "column",
    height: "100%",
    minHeight: 140,
    background: "linear-gradient(135deg, #6366f1 0%, #4f46e5 100%)",
    color: "#ffffff",
    borderRadius: 12,
    boxShadow: "0 2px 12px rgba(99, 102, 241, 0.25)",
    transition: "all 0.3s ease",
    "&:hover": {
      transform: "translateY(-2px)",
      boxShadow: "0 4px 20px rgba(99, 102, 241, 0.35)",
    },
    [theme.breakpoints.down('sm')]: {
      minHeight: 120,
      padding: theme.spacing(1.5),
    },
  },
  card4: {
    padding: theme.spacing(2),
    display: "flex",
    overflow: "auto",
    flexDirection: "column",
    height: "100%",
    minHeight: 140,
    background: "linear-gradient(135deg, #ec4899 0%, #db2777 100%)",
    color: "#ffffff",
    borderRadius: 12,
    boxShadow: "0 2px 12px rgba(236, 72, 153, 0.25)",
    transition: "all 0.3s ease",
    "&:hover": {
      transform: "translateY(-2px)",
      boxShadow: "0 4px 20px rgba(236, 72, 153, 0.35)",
    },
    [theme.breakpoints.down('sm')]: {
      minHeight: 120,
      padding: theme.spacing(1.5),
    },
  },
  card5: {
    padding: theme.spacing(2),
    display: "flex",
    overflow: "auto",
    flexDirection: "column",
    height: "100%",
    minHeight: 140,
    background: "linear-gradient(135deg, #06b6d4 0%, #0891b2 100%)",
    color: "#ffffff",
    borderRadius: 12,
    boxShadow: "0 2px 12px rgba(6, 182, 212, 0.25)",
    transition: "all 0.3s ease",
    "&:hover": {
      transform: "translateY(-2px)",
      boxShadow: "0 4px 20px rgba(6, 182, 212, 0.35)",
    },
    [theme.breakpoints.down('sm')]: {
      minHeight: 120,
      padding: theme.spacing(1.5),
    },
  },
  card6: {
    padding: theme.spacing(2),
    display: "flex",
    overflow: "auto",
    flexDirection: "column",
    height: "100%",
    minHeight: 140,
    background: "linear-gradient(135deg, #14b8a6 0%, #0d9488 100%)",
    color: "#ffffff",
    borderRadius: 12,
    boxShadow: "0 2px 12px rgba(20, 184, 166, 0.25)",
    transition: "all 0.3s ease",
    "&:hover": {
      transform: "translateY(-2px)",
      boxShadow: "0 4px 20px rgba(20, 184, 166, 0.35)",
    },
    [theme.breakpoints.down('sm')]: {
      minHeight: 120,
      padding: theme.spacing(1.5),
    },
  },
  card7: {
    padding: theme.spacing(2),
    display: "flex",
    overflow: "auto",
    flexDirection: "column",
    height: "100%",
    minHeight: 140,
    background: "linear-gradient(135deg, #f97316 0%, #ea580c 100%)",
    color: "#ffffff",
    borderRadius: 12,
    boxShadow: "0 2px 12px rgba(249, 115, 22, 0.25)",
    transition: "all 0.3s ease",
    "&:hover": {
      transform: "translateY(-2px)",
      boxShadow: "0 4px 20px rgba(249, 115, 22, 0.35)",
    },
    [theme.breakpoints.down('sm')]: {
      minHeight: 120,
      padding: theme.spacing(1.5),
    },
  },
  card8: {
    padding: theme.spacing(2),
    display: "flex",
    overflow: "auto",
    flexDirection: "column",
    height: "100%",
    minHeight: 140,
    background: "linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)",
    color: "#ffffff",
    borderRadius: 12,
    boxShadow: "0 2px 12px rgba(59, 130, 246, 0.25)",
    transition: "all 0.3s ease",
    "&:hover": {
      transform: "translateY(-2px)",
      boxShadow: "0 4px 20px rgba(59, 130, 246, 0.35)",
    },
    [theme.breakpoints.down('sm')]: {
      minHeight: 120,
      padding: theme.spacing(1.5),
    },
  },
  card9: {
    padding: theme.spacing(2),
    display: "flex",
    overflow: "auto",
    flexDirection: "column",
    height: "100%",
    minHeight: 140,
    background: "linear-gradient(135deg, #a855f7 0%, #9333ea 100%)",
    color: "#ffffff",
    borderRadius: 12,
    boxShadow: "0 2px 12px rgba(168, 85, 247, 0.25)",
    transition: "all 0.3s ease",
    "&:hover": {
      transform: "translateY(-2px)",
      boxShadow: "0 4px 20px rgba(168, 85, 247, 0.35)",
    },
    [theme.breakpoints.down('sm')]: {
      minHeight: 120,
      padding: theme.spacing(1.5),
    },
  },
  cardBadge: {
    display: "inline-flex",
    alignItems: "center",
    padding: "4px 10px",
    borderRadius: 12,
    fontSize: "11px",
    fontWeight: 600,
    marginTop: theme.spacing(1),
    backgroundColor: "rgba(255, 255, 255, 0.2)",
    backdropFilter: "blur(10px)",
  },
  cardSubtext: {
    fontSize: "11px",
    opacity: 0.85,
    marginTop: theme.spacing(0.5),
    fontWeight: 400,
    [theme.breakpoints.down('sm')]: {
      fontSize: "10px",
    },
  },
  fixedHeightPaper2: {
    padding: theme.spacing(2.5),
    display: "flex",
    overflow: "auto",
    flexDirection: "column",
    borderRadius: 12,
    backgroundColor: theme.palette.background.paper,
    boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
    border: `1px solid ${theme.palette.divider}`,
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(1.5),
    },
  },
}));

const Dashboard = () => {
  const classes = useStyles();
  const [counters, setCounters] = useState({});
  // eslint-disable-next-line no-unused-vars
  const [attendants, setAttendants] = useState([]);
  const [period, setPeriod] = useState(0);
  const [filterType, setFilterType] = useState(1);
  const [dateFrom, setDateFrom] = useState(moment("1", "D").format("YYYY-MM-DD"));
  const [dateTo, setDateTo] = useState(moment().format("YYYY-MM-DD"));
  const [loading, setLoading] = useState(false);
  const { find } = useDashboard();

  useEffect(() => {
    // ✅ CARGAR DATOS AUTOMÁTICAMENTE AL ABRIR EL DASHBOARD
    async function firstLoad() {
      // Establecer valores por defecto para mostrar datos útiles
      if (filterType === 1) {
        // Si es filtro por fecha, usar últimos 7 días por defecto
        const defaultDateFrom = moment().subtract(7, 'days').format("YYYY-MM-DD");
        const defaultDateTo = moment().format("YYYY-MM-DD");
        setDateFrom(defaultDateFrom);
        setDateTo(defaultDateTo);
      } else {
        // Si es filtro por período, usar últimos 7 días por defecto
        setPeriod(7);
      }
      
      // Cargar datos automáticamente
      await fetchData();
    }
    
    setTimeout(() => {
      firstLoad();
    }, 1000);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  
    async function handleChangePeriod(value) {
    setPeriod(value);
  }

  async function handleChangeFilterType(value) {
    setFilterType(value);
    if (value === 1) {
      setPeriod(0);
    } else {
      setDateFrom("");
      setDateTo("");
    }
  }

  async function fetchData() {
    setLoading(true);

    let params = {};

    if (period > 0) {
      params = {
        days: period,
      };
    }

    if (!isEmpty(dateFrom) && moment(dateFrom).isValid()) {
      params = {
        ...params,
        date_from: moment(dateFrom).format("YYYY-MM-DD"),
      };
    }

    if (!isEmpty(dateTo) && moment(dateTo).isValid()) {
      params = {
        ...params,
        date_to: moment(dateTo).format("YYYY-MM-DD"),
      };
    }

    // ✅ MEJORAR MANEJO DE PARÁMETROS - Si no hay parámetros, usar últimos 7 días por defecto
    if (Object.keys(params).length === 0) {
      params = {
        days: 7, // Usar últimos 7 días por defecto
      };
    }

    try {
      const data = await find(params);

      // ✅ MEJORAR MANEJO DE DATOS - Asegurar que counters tenga valores por defecto
      if (data && data.counters) {
        setCounters({
          avgSupportTime: data.counters.avgSupportTime || 0,
          avgWaitTime: data.counters.avgWaitTime || 0,
          supportHappening: data.counters.supportHappening || 0,
          supportPending: data.counters.supportPending || 0,
          supportFinished: data.counters.supportFinished || 0,
          leads: data.counters.leads || 0,
          totalCompanies: data.counters.totalCompanies || 0,
          totalWhatsappSessions: data.counters.totalWhatsappSessions || 0,
          totalMessages: data.counters.totalMessages || 0,
          messagesToday: data.counters.messagesToday || 0,
          ticketsToday: data.counters.ticketsToday || 0,
          ticketsYesterday: data.counters.ticketsYesterday || 0,
          totalTickets: data.counters.totalTickets || 0,
          activeUsers: data.counters.activeUsers || 0,
          totalUsers: data.counters.totalUsers || 0,
          totalContacts: data.counters.totalContacts || 0,
          activeContacts: data.counters.activeContacts || 0,
        });
      } else {
        // ✅ VALORES POR DEFECTO SI NO HAY DATOS
        setCounters({
          avgSupportTime: 0,
          avgWaitTime: 0,
          supportHappening: 0,
          supportPending: 0,
          supportFinished: 0,
          leads: 0,
          totalCompanies: 0,
          totalWhatsappSessions: 0,
          totalMessages: 0,
          messagesToday: 0,
          ticketsToday: 0,
          ticketsYesterday: 0,
          totalTickets: 0,
          activeUsers: 0,
          totalUsers: 0,
          totalContacts: 0,
          activeContacts: 0,
        });
      }

      if (isArray(data?.attendants)) {
        setAttendants(data.attendants);
      } else {
        setAttendants([]);
      }
    } catch (error) {
      // ✅ NO MOSTRAR ERROR SI ES 403 (Forbidden) - Probablemente falta token o expiró
      if (error.response && error.response.status === 403) {
        console.warn("⚠️ Error 403 al cargar dashboard - Token inválido o expirado");
        // No mostrar toast, el interceptor de API manejará el refresh token
      } else {
        console.error("Error al cargar datos del dashboard:", error);
        // Solo mostrar error si no es un error de autenticación
        if (error.response && error.response.status !== 401 && error.response.status !== 403) {
          toast.error(i18n.t("dashboard.errors.loadData"));
        }
      }
      
      // ✅ VALORES POR DEFECTO EN CASO DE ERROR
      setCounters({
        avgSupportTime: 0,
        avgWaitTime: 0,
        supportHappening: 0,
        supportPending: 0,
        supportFinished: 0,
        leads: 0,
        totalCompanies: 0,
        totalWhatsappSessions: 0,
        totalMessages: 0,
        messagesToday: 0,
        ticketsToday: 0,
        ticketsYesterday: 0,
        totalTickets: 0,
        activeUsers: 0,
        totalUsers: 0,
        totalContacts: 0,
        activeContacts: 0,
      });
      setAttendants([]);
    }

    setLoading(false);
  }

    function formatTime(minutes) {
    return moment()
      .startOf("day")
      .add(minutes, "minutes")
      .format("HH[h] mm[m]");
  }

    function renderFilters() {
    if (filterType === 1) {
      return (
        <>
          <Grid item xs={12} sm={6} md={4}>
            <TextField
              label={i18n.t("dashboard.filters.initialDate")}
              type="date"
              value={dateFrom}
              onChange={(e) => setDateFrom(e.target.value)}
              className={classes.fullWidth}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <TextField
              label={i18n.t("dashboard.filters.finalDate")}
              type="date"
              value={dateTo}
              onChange={(e) => setDateTo(e.target.value)}
              className={classes.fullWidth}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Grid>
        </>
      );
    } else {
      return (
        <Grid item xs={12} sm={6} md={4}>
          <FormControl className={classes.selectContainer}>
            <InputLabel id="period-selector-label">{i18n.t("dashboard.filters.period")}</InputLabel>
            <Select
              labelId="period-selector-label"
              id="period-selector"
              value={period}
              onChange={(e) => handleChangePeriod(e.target.value)}
            >
              <MenuItem value={0}>{i18n.t("dashboard.filters.noSelection")}</MenuItem>
              <MenuItem value={3}>{i18n.t("dashboard.filters.last3Days")}</MenuItem>
              <MenuItem value={7}>{i18n.t("dashboard.filters.last7Days")}</MenuItem>
              <MenuItem value={15}>{i18n.t("dashboard.filters.last15Days")}</MenuItem>
              <MenuItem value={30}>{i18n.t("dashboard.filters.last30Days")}</MenuItem>
              <MenuItem value={60}>{i18n.t("dashboard.filters.last60Days")}</MenuItem>
              <MenuItem value={90}>{i18n.t("dashboard.filters.last90Days")}</MenuItem>
            </Select>
            <FormHelperText>{i18n.t("dashboard.filters.selectPeriod")}</FormHelperText>
          </FormControl>
        </Grid>
      );
    }
  }

  return (
    <div>
      <Container maxWidth="lg" className={classes.container}>
        <Grid container spacing={3} justifyContent="flex-end">
		
				  {/* FILTROS */}
          <Grid item xs={12} sm={6} md={4}>
            <FormControl className={classes.selectContainer}>
              <InputLabel id="period-selector-label">{i18n.t("dashboard.filters.filterType")}</InputLabel>
              <Select
                labelId="period-selector-label"
                value={filterType}
                onChange={(e) => handleChangeFilterType(e.target.value)}
              >
                <MenuItem value={1}>{i18n.t("dashboard.filters.dateFilter")}</MenuItem>
                <MenuItem value={2}>{i18n.t("dashboard.filters.periodFilter")}</MenuItem>
              </Select>
              <FormHelperText>{i18n.t("dashboard.filters.selectPeriod")}</FormHelperText>
            </FormControl>
          </Grid>

          {renderFilters()}

          {/* BOTAO FILTRAR */}
          <Grid item xs={12} className={classes.alignRight}>
            <ButtonWithSpinner
              loading={loading}
              onClick={() => fetchData()}
              variant="contained"
              color="primary"
            >
              {i18n.t("dashboard.filters.filter")}
            </ButtonWithSpinner>
          </Grid>
          {/* EM ATENDIMENTO */}
          <Grid item xs={12} sm={6} md={3}>
            <Paper
              className={classes.card1}
              style={{ overflow: "hidden" }}
              elevation={0}
            >
              <Grid container spacing={2}>
                <Grid item xs={8}>
                  <Typography
                    component="h3"
                    variant="subtitle1"
                    style={{ fontWeight: 600, marginBottom: 6, fontSize: '14px' }}
                  >
                    {i18n.t("dashboard.cards.inConversation")}
                  </Typography>
                  <Typography
                    component="h1"
                    variant="h4"
                    style={{ fontWeight: 700, marginBottom: 4, fontSize: '28px' }}
                  >
                    {counters.supportHappening || 0}
                  </Typography>
                  <Typography className={classes.cardSubtext}>
                    Conversaciones activas
                  </Typography>
                </Grid>
                <Grid item xs={4} style={{ display: "flex", justifyContent: "flex-end", alignItems: "flex-start" }}>
                  <CallIcon
                    style={{
                      fontSize: 56,
                      color: "rgba(255, 255, 255, 0.9)",
                      opacity: 0.8,
                    }}
                  />
                </Grid>
              </Grid>
            </Paper>
          </Grid>

          {/* AGUARDANDO */}
          <Grid item xs={12} sm={6} md={3}>
            <Paper
              className={classes.card2}
              style={{ overflow: "hidden" }}
              elevation={0}
            >
              <Grid container spacing={2}>
                <Grid item xs={8}>
                  <Typography
                    component="h3"
                    variant="subtitle1"
                    style={{ fontWeight: 600, marginBottom: 6, fontSize: '14px' }}
                  >
                    {i18n.t("dashboard.cards.waiting")}
                  </Typography>
                  <Typography
                    component="h1"
                    variant="h4"
                    style={{ fontWeight: 700, marginBottom: 4, fontSize: '28px' }}
                  >
                    {counters.supportPending || 0}
                  </Typography>
                  <Typography className={classes.cardSubtext}>
                    En espera de atención
                  </Typography>
                </Grid>
                <Grid item xs={4} style={{ display: "flex", justifyContent: "flex-end", alignItems: "flex-start" }}>
                  <HourglassEmptyIcon
                    style={{
                      fontSize: 56,
                      color: "rgba(255, 255, 255, 0.9)",
                      opacity: 0.8,
                    }}
                  />
                </Grid>
              </Grid>
            </Paper>
          </Grid>

          {/* ATENDENTES ATIVOS */}
			  {/*<Grid item xs={12} sm={6} md={4}>
            <Paper
              className={classes.card6}
              style={{ overflow: "hidden" }}
              elevation={6}
            >
              <Grid container spacing={3}>
                <Grid item xs={8}>
                  <Typography
                    component="h3"
                    variant="h6"
                    paragraph
                  >
                    Conversas Ativas
                  </Typography>
                  <Grid item>
                    <Typography
                      component="h1"
                      variant="h4"
                    >
                      {GetUsers()}
                      <span
                        style={{ color: "#805753" }}
                      >
                        /{attendants.length}
                      </span>
                    </Typography>
                  </Grid>
                </Grid>
                <Grid item xs={4}>
                  <RecordVoiceOverIcon
                    style={{
                      fontSize: 100,
                      color: "#fff",
                    }}
                  />
                </Grid>
              </Grid>
            </Paper>
</Grid>*/}

          {/* FINALIZADOS */}
          <Grid item xs={12} sm={6} md={3}>
            <Paper
              className={classes.card3}
              style={{ overflow: "hidden" }}
              elevation={0}
            >
              <Grid container spacing={2}>
                <Grid item xs={8}>
                  <Typography
                    component="h3"
                    variant="subtitle1"
                    style={{ fontWeight: 600, marginBottom: 6, fontSize: '14px' }}
                  >
                    {i18n.t("dashboard.cards.finished")}
                  </Typography>
                  <Typography
                    component="h1"
                    variant="h4"
                    style={{ fontWeight: 700, marginBottom: 4, fontSize: '28px' }}
                  >
                    {counters.supportFinished || 0}
                  </Typography>
                  <Typography className={classes.cardSubtext}>
                    Conversaciones finalizadas
                  </Typography>
                </Grid>
                <Grid item xs={4} style={{ display: "flex", justifyContent: "flex-end", alignItems: "flex-start" }}>
                  <CheckCircleIcon
                    style={{
                      fontSize: 56,
                      color: "rgba(255, 255, 255, 0.9)",
                      opacity: 0.8,
                    }}
                  />
                </Grid>
              </Grid>
            </Paper>
          </Grid>

          {/* T.M. DE ATENDIMENTO */}
          <Grid item xs={12} sm={6} md={3}>
            <Paper
              className={classes.card8}
              style={{ overflow: "hidden" }}
              elevation={0}
            >
              <Grid container spacing={2}>
                <Grid item xs={8}>
                  <Typography
                    component="h3"
                    variant="subtitle1"
                    style={{ fontWeight: 600, marginBottom: 6, fontSize: '14px' }}
                  >
                    {i18n.t("dashboard.cards.avgConversationTime")}
                  </Typography>
                  <Typography
                    component="h1"
                    variant="h5"
                    style={{ fontWeight: 700, marginBottom: 4, fontSize: '24px' }}
                  >
                    {formatTime(counters.avgSupportTime || 0)}
                  </Typography>
                  <Typography className={classes.cardSubtext}>
                    Tiempo promedio
                  </Typography>
                </Grid>
                <Grid item xs={4} style={{ display: "flex", justifyContent: "flex-end", alignItems: "flex-start" }}>
                  <AccessAlarmIcon
                    style={{
                      fontSize: 56,
                      color: "rgba(255, 255, 255, 0.9)",
                      opacity: 0.8,
                    }}
                  />
                </Grid>
              </Grid>
            </Paper>
          </Grid>

          {/* T.M. DE ESPERA */}
          <Grid item xs={12} sm={6} md={3}>
            <Paper
              className={classes.card9}
              style={{ overflow: "hidden" }}
              elevation={0}
            >
              <Grid container spacing={2}>
                <Grid item xs={8}>
                  <Typography
                    component="h3"
                    variant="subtitle1"
                    style={{ fontWeight: 600, marginBottom: 6, fontSize: '14px' }}
                  >
                    {i18n.t("dashboard.cards.avgWaitTime")}
                  </Typography>
                  <Typography
                    component="h1"
                    variant="h5"
                    style={{ fontWeight: 700, marginBottom: 4, fontSize: '24px' }}
                  >
                    {formatTime(counters.avgWaitTime || 0)}
                  </Typography>
                  <Typography className={classes.cardSubtext}>
                    Tiempo promedio
                  </Typography>
                </Grid>
                <Grid item xs={4} style={{ display: "flex", justifyContent: "flex-end", alignItems: "flex-start" }}>
                  <TimerIcon
                    style={{
                      fontSize: 56,
                      color: "rgba(255, 255, 255, 0.9)",
                      opacity: 0.8,
                    }}
                  />
                </Grid>
              </Grid>
            </Paper>
          </Grid>

          {/* NUEVAS MÉTRICAS ADICIONALES */}
          {/* TICKETS HOY */}
          <Grid item xs={12} sm={6} md={3}>
            <Paper
              className={classes.card5}
              style={{ overflow: "hidden" }}
              elevation={0}
            >
              <Grid container spacing={2}>
                <Grid item xs={8}>
                  <Typography
                    component="h3"
                    variant="subtitle1"
                    style={{ fontWeight: 600, marginBottom: 6, fontSize: '14px' }}
                  >
                    Tickets Hoy
                  </Typography>
                  <Typography
                    component="h1"
                    variant="h4"
                    style={{ fontWeight: 700, marginBottom: 4, fontSize: '28px' }}
                  >
                    {counters.ticketsToday || 0}
                  </Typography>
                  <Typography className={classes.cardSubtext}>
                    {counters.ticketsYesterday ? `Ayer: ${counters.ticketsYesterday}` : 'Total: ' + (counters.totalTickets || 0)}
                  </Typography>
                </Grid>
                <Grid item xs={4} style={{ display: "flex", justifyContent: "flex-end", alignItems: "flex-start" }}>
                  <CheckCircleIcon
                    style={{
                      fontSize: 56,
                      color: "rgba(255, 255, 255, 0.9)",
                      opacity: 0.8,
                    }}
                  />
                </Grid>
              </Grid>
            </Paper>
          </Grid>

          {/* MENSAJES TOTALES */}
          <Grid item xs={12} sm={6} md={3}>
            <Paper
              className={classes.card6}
              style={{ overflow: "hidden" }}
              elevation={0}
            >
              <Grid container spacing={2}>
                <Grid item xs={8}>
                  <Typography
                    component="h3"
                    variant="subtitle1"
                    style={{ fontWeight: 600, marginBottom: 6, fontSize: '14px' }}
                  >
                    Mensajes Totales
                  </Typography>
                  <Typography
                    component="h1"
                    variant="h4"
                    style={{ fontWeight: 700, marginBottom: 4, fontSize: '28px' }}
                  >
                    {counters.totalMessages ? counters.totalMessages.toLocaleString() : 0}
                  </Typography>
                  <Typography className={classes.cardSubtext}>
                    {counters.messagesToday ? `Hoy: ${counters.messagesToday.toLocaleString()}` : 'Total de mensajes'}
                  </Typography>
                </Grid>
                <Grid item xs={4} style={{ display: "flex", justifyContent: "flex-end", alignItems: "flex-start" }}>
                  <CallIcon
                    style={{
                      fontSize: 56,
                      color: "rgba(255, 255, 255, 0.9)",
                      opacity: 0.8,
                    }}
                  />
                </Grid>
              </Grid>
            </Paper>
          </Grid>

          {/* USUARIOS ACTIVOS */}
          <Grid item xs={12} sm={6} md={3}>
            <Paper
              className={classes.card7}
              style={{ overflow: "hidden" }}
              elevation={0}
            >
              <Grid container spacing={2}>
                <Grid item xs={8}>
                  <Typography
                    component="h3"
                    variant="subtitle1"
                    style={{ fontWeight: 600, marginBottom: 6, fontSize: '14px' }}
                  >
                    Usuarios Activos
                  </Typography>
                  <Typography
                    component="h1"
                    variant="h4"
                    style={{ fontWeight: 700, marginBottom: 4, fontSize: '28px' }}
                  >
                    {counters.activeUsers || 0}
                  </Typography>
                  <Typography className={classes.cardSubtext}>
                    {counters.totalUsers ? `De ${counters.totalUsers} totales` : 'Usuarios en línea'}
                  </Typography>
                </Grid>
                <Grid item xs={4} style={{ display: "flex", justifyContent: "flex-end", alignItems: "flex-start" }}>
                  <GroupAddIcon
                    style={{
                      fontSize: 56,
                      color: "rgba(255, 255, 255, 0.9)",
                      opacity: 0.8,
                    }}
                  />
                </Grid>
              </Grid>
            </Paper>
          </Grid>
		 

          {/* TOTAL DE ATENDIMENTOS POR USUARIO */}
          <Grid item xs={12}>
            <Paper className={classes.fixedHeightPaper2}>
              <ChatsUser />
            </Paper>
          </Grid>

          {/* TOTAL DE ATENDIMENTOS */}
          <Grid item xs={12}>
            <Paper className={classes.fixedHeightPaper2}>
              <ChartsDate />
            </Paper>
          </Grid>

          {/* ✅ NUEVO REPORTE: ETIQUETAS POR PERIODO */}
          <Grid item xs={12}>
            <Paper className={classes.fixedHeightPaper2}>
              <TagsReport />
            </Paper>
          </Grid>

        </Grid>
      </Container >
    </div >
  );
};

export default Dashboard;
